import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgArrowDownSmall = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 7, height: 9, viewBox: "0 0 7 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M3.5 -1.09278e-07L3.5 7.5M3.5 7.5L6 5M3.5 7.5L1 5", stroke: "#CCCCCC", strokeWidth: 1.2 }) });
const ForwardRef = forwardRef(SvgArrowDownSmall);
export { ForwardRef as ReactComponent };
